module.exports = __webpack_public_path__ + "img/3.c970d8e6.jpg";